// extracted by mini-css-extract-plugin
export var mainModuleStyle = "fEOfr";